var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTicket(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.97607 8.89501C2.7625 8.89501 3.51671 9.20742 4.07279 9.7635C4.62887 10.3196 4.94128 11.0738 4.94128 11.8602C4.94128 12.6466 4.62887 13.4009 4.07279 13.9569C3.51671 14.513 2.7625 14.8254 1.97607 14.8254V16.8022C1.97607 17.3265 2.18434 17.8293 2.55507 18.2C2.92579 18.5708 3.4286 18.779 3.95288 18.779H19.7673C20.2916 18.779 20.7944 18.5708 21.1651 18.2C21.5358 17.8293 21.7441 17.3265 21.7441 16.8022V14.8254C20.9577 14.8254 20.2035 14.513 19.6474 13.9569C19.0913 13.4009 18.7789 12.6466 18.7789 11.8602C18.7789 11.0738 19.0913 10.3196 19.6474 9.7635C20.2035 9.20742 20.9577 8.89501 21.7441 8.89501V6.91821C21.7441 6.39393 21.5358 5.89112 21.1651 5.5204C20.7944 5.14968 20.2916 4.94141 19.7673 4.94141H3.95288C3.4286 4.94141 2.92579 5.14968 2.55507 5.5204C2.18434 5.89112 1.97607 6.39393 1.97607 6.91821V8.89501Z",
    stroke: "#F6FBFE",
    strokeWidth: 1.4826,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.85 4.94141V6.91821",
    stroke: "#F6FBFE",
    strokeWidth: 1.4826,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.85 16.8027V18.7795",
    stroke: "#F6FBFE",
    strokeWidth: 1.4826,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.85 10.8711V12.8479",
    stroke: "#F6FBFE",
    strokeWidth: 1.4826,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTicket);
export default __webpack_public_path__ + "static/media/ticket.04d249e2e2f997ba86ef78b4e08e9dd3.svg";
export { ForwardRef as ReactComponent };